import { City } from "../models/City";
import { SongBase } from "../models/Song";

export const filterByName = (object: City | SongBase, searchQuery: string) => {
    if (searchQuery === "") {
        return object
    }

    let value = ""
    if (isCity(object)) {
        value = object.name
    }

    if (isSongBase(object)) {
        value = object.songName
    }
    if (!value || value === "") {
        return object
    }

    if (value.toLowerCase().includes(searchQuery.toLowerCase())) {
        return object
    }
}

const isCity = (object: City | SongBase): object is City => (object as City).name !== undefined
const isSongBase = (object: City | SongBase): object is SongBase => (object as SongBase).songName !== undefined